import { Injectable } from "@angular/core";
import { addDays, differenceInDays } from "date-fns";

@Injectable({
  providedIn: "root",
})
export class ProductService {
  addDays(days: number): Date {
    return addDays(new Date(), days);
  }

  getExpiryDisplayText(expiryDate: string | Date): { text: string; isExpired: boolean } {
    const expiry = new Date(expiryDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const isExpired = expiry < today;

    if (isExpired) {
      return { text: "Product is expired!", isExpired: true };
    }

    const diffDays = differenceInDays(expiry, today);
    return {
      text: `Expires in ${diffDays} day${diffDays === 1 ? "" : "s"}`,
      isExpired: false,
    };
  }
}
